// ---------------------------------------------------
// ---------------------------------------------------
// IMPORTS
import {
  cookiemunch
} from "@dunks1980/cookiemunch";
import "@dunks1980/cookiemunch/cookiemunch_flat_dark.min.css";
import cookie_svgimage from "@dunks1980/cookiemunch/cookiemunch_flat_dark.svg";
// ---------------------------------------------------
// ---------------------------------------------------
// COOKIES
function googleanalytics() {
  // Google Analytics
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag('config', 'G-NV1W1YN9D7');
  window['ga-disable-GA_MEASUREMENT_ID'] = false;
}

function googleanalytics_off() {
  // Google Analytics
  window['ga-disable-GA_MEASUREMENT_ID'] = true;
}

function addScript(src, async, defer, id) {
  var s = document.createElement('script');
  s.src = src;
  s.async = async;
  s.defer = defer;
  s.id = id;
  var checkId;
  if (id) {
    checkId = document.getElementById(id);
    if (checkId) {
      checkId.remove();
    }
  }
  document.body.appendChild(s);
}

function removeScript(uri) {
  if (!uri) {
    return false;
  }
  var s = document.querySelector(`[src="${uri}"]`);
  if (s) {
    s.remove();
  }
}

function inspectlet() {
  try {
    (function () {
      window.__insp = window.__insp || [];
      __insp.push(['wid', 510927350]);
      var ldinsp = function () {
        if (typeof window.__inspld != "undefined") return;
        window.__inspld = 1;
        var insp = document.createElement('script');
        insp.type = 'text/javascript';
        insp.async = true;
        insp.id = "inspsync";
        insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=510927350&r=' + Math.floor(new Date().getTime() / 3600000);
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(insp, x);
      };
      setTimeout(ldinsp, 0);
    })();
  } catch (error) {}
}

function inspectlet_off() {
  //console.log('Inspectlet declined.');
}

var options = {
  settings: {
    //reload: true,
    cookie_title: 'Domposer cookies',
    cookie_image: cookie_svgimage,
    check_switch_icons: true,
    first_visit_checked: true,
    hide_icon: true,
    start_dropdown_closed: true
  },
  cookies: [{
      id: "gtm",
      name: "Google tag manager",
      used_for: "To collect analyitical data and monitor performance.",
      url_text: "Privacy",
      url: "https://policies.google.com/privacy",
      accepted_function: googleanalytics,
      declined_function: googleanalytics_off
    },
    {
      id: "inspectlet",
      name: "Inspectlet",
      used_for: "To collect analyitical data and monitor page views. Reload page to apply option.",
      url_text: "Privacy",
      url: "https://www.inspectlet.com/terms-of-service#privacy",
      accepted_function: inspectlet,
      declined_function: inspectlet_off
    },
    {
      id: "statcounter",
      name: "Statcounter",
      used_for: "To collect analyitical data and monitor page views.",
      url_text: "Privacy",
      url: "https://statcounter.com/about/legal/",
      accepted_function: function () {
        window.sc_project = 12753810;
        window.sc_invisible = 1;
        window.sc_security = "df48606b";
        addScript('https://www.statcounter.com/counter/counter.js', true, false, 'statcounter');
      },
      declined_function: function () {
        window.sc_project = undefined;
        window.sc_invisible = undefined;
        window.sc_security = undefined;
        removeScript('https://www.statcounter.com/counter/counter.js');
      }
    }
  ],
  required_cookies: [{
    name: "Cloudflare",
    used_for: "Cookie is set by Cloudflare to speed up their load times...",
    url_text: "Privacy policy",
    url: "https://www.cloudflare.com/en-gb/privacypolicy/"
  }]
};

cookiemunch(options);

window.onload = function(){ 
  document.getElementById("cookie-icon").onclick = function () {
    window.cookiemunch_toggle_popup();
  };
};
